import { ReactComponent as iconAdd } from "./../../assets/icons/add.svg";
import { ReactComponent as iconEdit } from "./../../assets/icons/edit.svg";
import { ReactComponent as iconDelete } from "./../../assets/icons/delete.svg";
import { ReactComponent as iconClose } from "./../../assets/icons/close.svg";
import { ReactComponent as iconCheck } from "./../../assets/icons/check.svg";
import { ReactComponent as iconExpand } from "./../../assets/icons/arrow_expand.svg";
import { ReactComponent as iconGallery } from "./../../assets/icons/gallery.svg";
import { ReactComponent as iconUpload } from "./../../assets/icons/upload.svg";
import { ReactComponent as iconSearch } from "./../../assets/icons/search.svg";

import imageDelete from "./../../assets/images/image_delete.png";

const assets = {
  iconAdd,
  iconEdit,
  iconDelete,
  iconClose,
  iconCheck,
  iconExpand,
  iconGallery,
  iconUpload,
  iconSearch,
  imageDelete,
};

export default assets;
